import React from 'react';
import ReactDOM from 'react-dom';
import AppRoute from './AppRoute';
import './index.css'
import 'bootstrap/dist/css/bootstrap.min.css';

// redux and redux thunk
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import rootReducer from './redux/rootReducers';

// store
const store = createStore(rootReducer, applyMiddleware(thunk))


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppRoute />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);